import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, Grid, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { Severity } from '../../types';
import { DeviceLinkContext } from './DeviceLinkContext';
const LinkingLocation = (props) => {
    const { setLocation, setUpdateLocation } = props;
    const { location, updateLocation } = useContext(DeviceLinkContext);
    const [{ UserFunctions: userFunctions }] = useContext(AppMainViewContext);
    const [refreshDisabled, setRefreshDisabled] = useState(false);
    const getAndSetCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const initLoc = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                if (setLocation) {
                    const message = {
                        id: uuidv4(),
                        content: `Updated Location`,
                        label: '',
                        type: 'MessageBar',
                        severity: Severity.success,
                    };
                    if (location !== undefined) {
                        userFunctions.setUserMessage(message);
                    }
                    setTimeout(() => {
                        userFunctions.dismissUserMessage(message);
                        setRefreshDisabled(false);
                    }, 800);
                    setLocation(initLoc);
                    setRefreshDisabled(true);
                }
            }, (error) => {
                alert('Error occurred: ' + error.message);
            }, { enableHighAccuracy: true, maximumAge: 10000 });
        }
        else {
            alert('Geolocation is not supported by this browser.');
        }
    };
    useEffect(() => {
        getAndSetCurrentLocation();
    }, [updateLocation]);
    return (_jsxs("div", { children: [_jsxs(Grid, { id: 'Get-Location', container: true, size: { xs: 12 }, spacing: 2, sx: {
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, children: [_jsx(Grid, { children: _jsxs(Stack, { direction: "row", 
                            // spacing={1}
                            sx: {
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                            }, children: [_jsx(Typography, { variant: "body2", component: "p", color: "primary", children: `1) Set Location?` }), _jsx(Checkbox, { checked: updateLocation, onClick: () => setUpdateLocation && setUpdateLocation(!updateLocation) })] }) }), updateLocation && location && (_jsx(Grid, { children: _jsx(Button, { disabled: refreshDisabled, variant: "outlined", onClick: () => getAndSetCurrentLocation(), children: "Refresh Location" }) }))] }), updateLocation && location && (_jsxs(Grid, { id: 'Get-Location', container: true, size: { xs: 12 }, paddingTop: '5px', paddingBottom: '5px', sx: {
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, children: [_jsx(Grid, { children: _jsx(TextField, { disabled: true, size: 'small', value: location?.lat, slotProps: {
                                input: {
                                    style: { width: '170px' },
                                    startAdornment: _jsx(InputAdornment, { position: "start", children: `Lat: ` }),
                                },
                            } }) }), _jsx(Grid, { children: _jsx(TextField, { disabled: true, size: 'small', value: location?.lng, slotProps: {
                                input: {
                                    style: { width: '170px' },
                                    startAdornment: _jsx(InputAdornment, { position: "start", children: `Lng: ` }),
                                },
                            } }) })] }))] }));
};
export default LinkingLocation;
